import "./mobx-config";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// Sentry.init({
//   dsn: `${process.env.REACT_APP_KSA_SENTRY_URL}`,
//   integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
//   tracesSampleRate: 1.0,
// });

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>,
  document.getElementById("root")
);

reportWebVitals();
